import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonsModule } from '../button/button.module';
import { DropdownModule } from '../dropdown/dropdown.module';
import { IconModule } from '../icon/icon.module';
import { AxisCalendarComponent } from './axis-calendar.component';
import { CalendarInnerComponent } from './calendar-inner.component';
import { CalendarComponent } from './calendar.component';
import { CalendarService } from './calendar.shared.service';
import { AxisDayButtonCalendarComponent } from './calendar.daybtn.component';
import { DayPickerCalendarComponent } from './calendar.daypicker.component';
import { MonthPickerCalendarComponent } from './calendar.monthpicker.component';
import { YearPickerCalendarComponent } from './calendar.yearpicker.component';

@NgModule({
  imports: [
    ButtonsModule,
    CommonModule,
    DropdownModule,
    FormsModule,
    IconModule
  ],
  declarations: [
    CalendarComponent,
    AxisDayButtonCalendarComponent,
    AxisCalendarComponent,
    CalendarInnerComponent,
    DayPickerCalendarComponent,
    MonthPickerCalendarComponent,
    YearPickerCalendarComponent
  ],
  exports: [
    CalendarComponent,
    AxisDayButtonCalendarComponent,
    AxisCalendarComponent,
    CalendarInnerComponent,
    DayPickerCalendarComponent,
    MonthPickerCalendarComponent,
    YearPickerCalendarComponent
  ],
  providers: [
    CalendarService
  ],
  entryComponents: [
    CalendarComponent
  ]
})
export class CalendarModule {}
